import clx from 'classnames';
import styles from './Spinner.module.scss';

/**
 * @param {boolean} inline — spinner nel flusso (calendario)
 * @param {boolean} blocking — overlay assoluto sul parent (es. TaskModal); non copre Header/Sidebar
 */
const Spinner = ({ inline = false, blocking = false }) => (
  <div
    className={clx(styles.loader, {
      [styles.loader_inline]: inline,
      [styles.loader_blocking]: blocking,
    })}
    aria-hidden="true"
  >
    <div className={styles.spinner__wrapper}>
      <div className={styles.spinner} />
    </div>
  </div>
);

export default Spinner;
